/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-param-reassign */
import React, { useCallback, useState, useEffect } from 'react';
import ptbr from 'date-fns/locale/pt-BR';
import DatePicker, { registerLocale } from 'react-datepicker';
import moment from 'moment';

import 'react-datepicker/dist/react-datepicker.css';

import { Container, Content } from './styles';
import Table from '../../../components/table';
import api from '../../../services/api';

registerLocale('ptbr', ptbr);

const Simulation: React.FC = () => {
  const [startDate, setStartDate] = useState(new Date(
    new Date().setDate(new Date().getDate() - 30),
  ));
  const [endDate, setEndDate] = useState(new Date(
    new Date().setDate(new Date().getDate() + 1),
  ));
  const [data, setData] = useState([]);

  const handleGetSimulations = useCallback(async () => {
    const simulations = await api.post('/simulations/list',
      { initial: startDate, final: endDate },
      { headers: { Authorization: `Bearer ${localStorage.getItem('@EABApi:token')}` } });

    simulations.data.map((item: any) => {
      if (item.kind === 'valor') {
        item.kind = 'R$';
      } else {
        item.kind = 'KwH';
      }

      item.created_at = moment(item.created_at).format('D/MM/Y');

      return null;
    });

    setData(simulations.data);
  }, [startDate, endDate]);

  useEffect(() => {
    handleGetSimulations();
  }, [handleGetSimulations]);

  return (
    <Container>
      <h1>Listagem de Simulações</h1>
      <Content>
        <Table
          columns={[
            { title: 'Nome', field: 'name' },
            { title: 'Sobrenome', field: 'surname' },
            { title: 'Telefone', field: 'phone' },
            { title: 'Whatsapp', field: 'whatsapp' },
            { title: 'Email', field: 'email' },
            { title: 'Pessoa', field: 'person_type' },
            { title: 'R$ / KwH', field: 'kind' },
            { title: 'Valor mensal', field: 'monthly_value' },
            { title: 'Simulado Em', field: 'created_at' },
          ]}
          data={data}
        />
      </Content>
      <br />
      <DatePicker selected={startDate} onChange={(date: Date) => setStartDate(date)} locale="ptbr" dateFormat="dd/MM/Y" />
      {' à '}
      <DatePicker selected={endDate} onChange={(date: Date) => setEndDate(date)} locale="ptbr" dateFormat="dd/MM/Y" />
    </Container>
  );
};

export default Simulation;
